export default function Select({ label, options, ...props }) {
  return (
    <label className="field">
      <div className="label">{label}</div>
      <select className="input" {...props}>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
